import { useState } from "react";
import {
  Box,
  Button,
  // CircularProgress,
  Typography,
} from "@mui/material";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import { ElevatedCard } from "../../../components/elevated-card";
import { Modal } from "../../../components/backdrop-modal";
import { PDFView } from "../../../components/pdf-viewer";
// import { JobseekersFeature } from "../../../features/jobseekers";
// import { useDispatch } from "react-redux";

export const JobseekerCoverLetterPdf = ({
  jobseekerId,
  jobseekerName,
  coverLetter,
}) => {
  const [viewCoverLetter, setViewCoverLetter] = useState(false);
  const [noCoverLetterModalOpen, setNoCoverLetterModalOpen] = useState(false);

  return (
    <ElevatedCard sx={{ width: "100%", p: { xs: "1rem", md: "1.6rem" } }}>
      <Box width="100%">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontSize: "1.2rem", fontWeight: "bold" }}>
            Cover Letter
          </Typography>
          <Box sx={{ display: "flex" }}>
            <Button
              sx={{ borderRadius: "2.6rem", height: "2.2rem" }}
              onClick={() => {
                if (typeof coverLetter === "boolean" && coverLetter)
                  return setViewCoverLetter((prev) => !prev);
                setNoCoverLetterModalOpen(true);
              }}
            >
              View
            </Button>
            {/* <DownloadResumeButton
              jobseekerId={jobseekerId}
              jobseekerName={jobseekerName}
              coverLetter={coverLetter}
              noCoverLetterModalOpen={noCoverLetterModalOpen}
              setNoCoverLetterModalOpen={setNoCoverLetterModalOpen}
            /> */}
          </Box>
        </Box>
        <Modal
          headerTitle="Jobseeker Cover Letter"
          open={viewCoverLetter}
          onClose={() => setViewCoverLetter((prev) => !prev)}
        >
          <PDFView
            url={`${process.env.REACT_APP_API_BASE_URL}/jobseekers/${jobseekerId}/cover-letters`}
          />
        </Modal>
      </Box>
      <NoCoverLetterModal
        open={noCoverLetterModalOpen}
        onClose={() => setNoCoverLetterModalOpen(false)}
        coverLetter={coverLetter}
      />
    </ElevatedCard>
  );
};

// const DownloadResumeButton = ({
//   jobseekerId,
//   jobseekerName,
//   coverLetter,
//   setNoCoverLetterModalOpen,
// }) => {
//   const dispatch = useDispatch();
//   const [downloading, setDownloading] = useState(false);

//   const handleDownload = async () => {
//     if (!coverLetter) return setNoCoverLetterModalOpen(true);
//     setDownloading(true);
//     await JobseekersFeature.downloadJobseekerResume({
//       jobseekerId,
//       jobseekerName,
//     })(dispatch);
//     setDownloading(false);
//   };

//   return (
//     <Button
//       sx={{ borderRadius: "2.6rem", height: "2.2rem" }}
//       onClick={handleDownload}
//       disabled={downloading}
//     >
//       {downloading ? <CircularProgress size="1.4rem" /> : "Download"}
//     </Button>
//   );
// };

const NoCoverLetterModal = ({ open, onClose, coverLetter }) => {
  return (
    <Modal
      headerTitle={
        coverLetter?.cover_letter_type === "text" && coverLetter?.text
          ? "Cover Letter"
          : "No Cover Letter"
      }
      open={open}
      onClose={onClose}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          // justifyContent: "center",
          maxHeight: "60vh",
          overflowY: "auto",
          // pt: "5rem",
        }}
      >
        {coverLetter?.cover_letter_type === "text" && coverLetter?.text ? (
          coverLetter?.text.split("\n").map((line, index) => (
            <Typography key={index} sx={{ fontSize: "1rem" }}>
              {line}
            </Typography>
          ))
        ) : (
          <Typography
            sx={{ fontSize: "1.2rem", fontWeight: "bold", textAlign: "center" }}
          >
            This job seeker has not added the cover letter.
          </Typography>
        )}
      </Box>
    </Modal>
  );
};
